import React from 'react';

// Components
import TemplateItem from '../TemplateItem';

// Styles
import { SectionWrapper, FollowupWrapper, FollowupHeading } from './styled';
import { STEP_TYPES } from 'utils/templates';
import SectionRenderer from 'components/TaskChecklist/SectionRenderer';

interface PropTypes {
  followupQuestions: any[];
  isLogSubmitted: boolean;
  onChangeCb: any | ((item: any, value: any) => void);
  automations?: any;
  childItemsMap?: any;
  lastUpdatedRef?: any;
  onNotePostToItem: any;
  handleUpdateItemNote: any;
  handleDeleteChecklistItemNote: any;
  handleCreateCorrectiveTask: any;
  showTimeStamp?: boolean;
  itemErrors?: any;

  checklistProgAndScore?: any;
  localChecklist?: any;
  onResponseToItem?: any;
  isActionsAllowed?: any;
  taskLocation?: any;
  isMobileDeviceMd?: any;
  checkVisibility?: any;
  checkListLogHashes?: any;
  updateMultipleItems?: (items: any, value: any) => void;
  handleShowUploadModal?: (item: any) => void;
}

const FollowupQuestions = ({
  followupQuestions,
  isLogSubmitted,
  onChangeCb,
  automations,
  childItemsMap,
  lastUpdatedRef,
  onNotePostToItem,
  handleUpdateItemNote,
  handleDeleteChecklistItemNote,
  handleCreateCorrectiveTask,
  showTimeStamp,
  itemErrors,

  checklistProgAndScore,
  localChecklist,
  onResponseToItem,
  isActionsAllowed,
  taskLocation,
  isMobileDeviceMd,
  checkVisibility,
  checkListLogHashes,
  updateMultipleItems,
  handleShowUploadModal,
}: PropTypes) => {
  return (
    <SectionWrapper>
      <FollowupWrapper>
        <FollowupHeading>Follow Up Questions</FollowupHeading>
      </FollowupWrapper>
      {followupQuestions?.map((followUp) =>
        followUp?.map((originalChildItem) => {
          let childItem = originalChildItem;
          if (childItem?.type !== STEP_TYPES.HEADER) {
            childItem = localChecklist?.TaskChecklistItems?.find(
              (item) => item?.id === originalChildItem?.id,
            );
          }

          const isVisible = checkVisibility?.(childItem);

          return childItem.type === STEP_TYPES.HEADER ? (
            <SectionRenderer
              key={childItem.id}
              section={childItem}
              checklistProgAndScore={checklistProgAndScore}
              sectionScores={checklistProgAndScore?.sectionScores}
              localChecklist={localChecklist}
              isLogSubmitted={isLogSubmitted}
              onResponseToItem={onResponseToItem}
              automations={automations}
              childItemsMap={childItemsMap}
              lastUpdatedRef={lastUpdatedRef}
              onNotePostToItem={onNotePostToItem}
              handleUpdateItemNote={handleUpdateItemNote}
              handleDeleteChecklistItemNote={handleDeleteChecklistItemNote}
              handleCreateCorrectiveTask={handleCreateCorrectiveTask}
              itemErrors={itemErrors}
              handleShowUploadModal={handleShowUploadModal}
              isActionsAllowed={isActionsAllowed}
              taskLocation={taskLocation}
              isMobileDeviceMd={isMobileDeviceMd}
              checkListLogHashes={checkListLogHashes}
              isSectionVisible={isVisible}
              updateMultipleItems={updateMultipleItems}
              checkVisibility={checkVisibility}
            />
          ) : (
            <TemplateItem
              key={childItem?.id}
              item={childItem}
              localChecklist={localChecklist}
              lastUpdatedRef={lastUpdatedRef}
              automations={automations}
              childItemsMap={childItemsMap}
              isLogSubmitted={isLogSubmitted}
              onChangeCb={onChangeCb}
              onNotePostToItem={onNotePostToItem}
              handleUpdateItemNote={handleUpdateItemNote}
              handleDeleteChecklistItemNote={handleDeleteChecklistItemNote}
              handleCreateCorrectiveTask={handleCreateCorrectiveTask}
              showTimeStamp={showTimeStamp}
              itemErrors={itemErrors}
              handleShowUploadModal={handleShowUploadModal}
              checklistProgAndScore={checklistProgAndScore}
              onResponseToItem={onResponseToItem}
              isItemVisible={isVisible}
              updateMultipleItems={updateMultipleItems}
              checkVisibility={checkVisibility}
              checkListLogHashes={checkListLogHashes}
            />
          );
        }),
      )}
    </SectionWrapper>
  );
};

export default FollowupQuestions;
